import { httpGet, httpPut } from '../../data'
import type { INotification, INotificationList } from '../../../domain/interfaces/INotification'

const notificationsURL = '/notifications'

export async function notificationsGet(skip: number | string, limit: number | string) {
  return await httpGet<INotificationList>(`${notificationsURL}?skip=${skip}&limit=${limit}`, false)
}

export async function notificationMarkAsRead(id: string) {
  return await httpPut<INotification>(`${notificationsURL}/markAsRead/${id}`, {})
}
